import React, { useRef } from 'react';
var VeltInlineCommentsSectionSortingDropdownContentItem = function (props) {
    var defaultCondition = props.defaultCondition, sortOption = props.sortOption, sortOptionText = props.sortOptionText, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-item", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "sort-option": sortOption, "sort-option-text": sortOptionText }, children));
};
export default VeltInlineCommentsSectionSortingDropdownContentItem;
